// extracted by mini-css-extract-plugin
export default {"spinner":"SmallSpinner_spinner__DW9fh","spin":"SmallSpinner_spin__P9RA9"};